import { Component, ViewChild } from '@angular/core'
import { Nav, Platform } from 'ionic-angular'
import { StatusBar } from '@ionic-native/status-bar'
import { SplashScreen } from '@ionic-native/splash-screen'
import { TranslateService } from '@ngx-translate/core'
import { initTranslate } from "../utils/lang-utils"

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  rootPage = "home"

  constructor(private platform: Platform,
              private statusBar: StatusBar,
              private splashScreen: SplashScreen,
              private translateService: TranslateService) {
    this.initializeApp()
  }

  initializeApp() {
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.statusBar.styleDefault();
      this.splashScreen.hide();
      //this.translateService.get("").subscribe(_ => {
      this.translateService.setDefaultLang("de")
	      initTranslate(this.translateService)
        //this.rootPage = "home"
      //})
    });
  }

  openPage(page) {
    this.nav.setRoot(this.rootPage)
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts